import type { ReactNode } from 'react';
import { Icon, type IconName } from '../Icon';

interface CalloutProps {
    type?: 'info' | 'tip' | 'warn' | 'danger' | 'success';
    title?: string;
    children: ReactNode;
}

const TYPE_ICON: Record<NonNullable<CalloutProps['type']>, IconName> = {
    info: 'info',
    tip: 'sparkles',
    warn: 'alert-triangle',
    danger: 'alert-triangle',
    success: 'check',
};

const TYPE_LABEL: Record<NonNullable<CalloutProps['type']>, string> = {
    info: 'Bon à savoir',
    tip: 'Astuce',
    warn: 'Attention',
    danger: 'Risque',
    success: 'Parfait',
};

export function Callout({ type = 'info', title, children }: CalloutProps) {
    return (
        <aside className={`doc-callout is-${type}`}>
            <div className="doc-callout-head">
                <Icon name={TYPE_ICON[type]} size={15} />
                <strong>{title ?? TYPE_LABEL[type]}</strong>
            </div>
            <div className="doc-callout-body">{children}</div>
        </aside>
    );
}
